import { Pipe, PipeTransform } from '@angular/core';
import { UserStateService } from '../services/user-state.service';

@Pipe({
    name: 'walletLabel',
    pure: false,
    standalone: true
})
export class WalletLabelPipe implements PipeTransform {
  constructor(private readonly userState: UserStateService) {}

  transform(value: string | null | undefined): string {
    if (typeof value !== 'string' || !value) {
      return value || '';
    }

    const isRegulated = this.userState.regulated;
    if (!isRegulated) {
      return value;
    }

    // Hosted pathway replacements: Wallet -> Account
    return value
      .replace(/My Wallet/gi, (match) => this.matchCase(match, 'My account'))
      .replace(/\bWallet\b/gi, (match) => this.matchCase(match, 'Account'));
  }

  private matchCase(source: string, target: string): string {
    if (source === source.toUpperCase()) {
      return target.toUpperCase();
    }

    if (source[0] === source[0].toUpperCase()) {
      return target.charAt(0).toUpperCase() + target.slice(1);
    }

    return target.toLowerCase();
  }
}
